import React from 'react';
import ContentLoader, { Facebook } from 'react-content-loader';

export const Loader = () => (
    <div className='content-loader'>
        <Facebook />
    </div>
);